/** Story UUID for admin “Test canvas” and public play parity (`/puzzle/play-jigsaw/:storyId`). */
export const TEST_JIGSAW_CANVAS_STORY_ID = "b9776fd4-3b6f-49fc-97c0-826eec26de4a";
